import type { InjectionKey } from "vue";

/**
 * Answers a pending tool-approval request from the agent.
 * Provided by ChatPanel (wired to the Chat instance's addToolApprovalResponse) and injected by
 * AssistantMessage, which renders the ToolApprovalCard deep in the message tree. This avoids
 * threading approval-specific emits through the generic message router components.
 */
export type ApprovalResponder = (approvalId: string, approved: boolean, reason?: string) => void;

export const ApprovalResponderKey: InjectionKey<ApprovalResponder> = Symbol("chat-approval-responder");
